"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { Box } from "~/components/Box/Box";
import { Button } from "~/components/Button/Button";
import { ButtonLink } from "~/components/ButtonLink/ButtonLink";
import { Divider } from "~/components/Divider/Divider";
import { PageWrapper } from "~/components/PageWrapper/PageWrapper";
import { Text } from "~/components/Text/Text";
import { TextField } from "~/components/TextField/TextField";
import { VIEWPORT_MD } from "~/constants";

export default function LandingPage() {
  const router = useRouter();
  const [search, setSearch] = useState("");
  const trimmed = search.trim();

  function handleSearchSubmit() {
    if (trimmed === "") {
      router.push(`/select-location`);
      return;
    }

    router.push(
      `/select-location?search=${encodeURIComponent(trimmed)}&sortMode=manualSearch`,
    );
  }

  return (
    <PageWrapper background="jets-black">
      <Box
        display="flex"
        alignItems="center"
        flexDirection="column"
        justifyContent="spaceAround"
        padding="4"
        gap="10"
      >
        <Image
          src="/images/jetspizzalogo_desktop.png"
          alt="Jet's Pizza"
          width={320}
          height={100}
          style={{ objectFit: "contain" }}
        />
        <Box
          width="full"
          display="flex"
          alignItems="center"
          flexDirection="column"
          gap="5"
          style={{ maxWidth: VIEWPORT_MD }}
        >
          <Text
            weight="semi-strong"
            size="xxlarge"
            font="accent"
            color="neutral-100"
          >
            START YOUR ORDER
          </Text>
          <ButtonLink primary href="/select-location?sortMode=geolocate">
            FIND MY NEAREST STORE
          </ButtonLink>
        </Box>

        <Box width="full" paddingX="15" style={{ maxWidth: VIEWPORT_MD }}>
          <Divider color="neutral-100" text="OR" />
        </Box>

        <Box
          width="full"
          display="flex"
          alignItems="center"
          flexDirection="column"
          gap="4"
          style={{ maxWidth: VIEWPORT_MD }}
        >
          <Box width="full">
            <TextField
              centered
              placeholder="Enter City, State, or ZIP"
              value={search}
              onChange={setSearch}
              onKeyDown={(e) => {
                if (e.key === "Enter" && trimmed !== "") {
                  handleSearchSubmit();
                }
              }}
            />
          </Box>
          <Button primary onClick={handleSearchSubmit}>
            SEARCH
          </Button>
        </Box>
      </Box>
    </PageWrapper>
  );
}
